import React from "react";

const Copyright = () => {
  return (
    <div className="bg-primary w-full h-[118px] px-3">
      <div className="w-full h-full max-w-[1362px] mx-auto flex items-center text-white md:xs:text-xl text-base text-sm">
        Copyright © 2023 Powered by <span className="font-semibold">&nbsp;TrueApex</span>
      </div>
    </div>
  );
};

export default Copyright;
